import { create } from 'zustand';

import type { ChargerFlow, ChargerFlowErrors } from '@models/chargerFlows';

type ChargerFlowsState = {
  chargerFlows: ChargerFlow[];
  editChargerFlow: ChargerFlow | null;
  editChargerFlowErrors: ChargerFlowErrors | null;
  setChargerFlows: (flows: ChargerFlow[]) => void;
  setEditChargerFlow: (flow: ChargerFlow) => void;
  setEditChargerFlowsErrors: (errors: ChargerFlowErrors) => void;
  resetChargerFlows: () => void;
  resetEditChargerFlow: () => void;
  resetEditChargerFlowErrors: () => void;
};

export const useAllChargerFlowsStorage = create<ChargerFlowsState>((set) => ({
  chargerFlows: [],
  editChargerFlow: null,
  editChargerFlowErrors: null,
  setChargerFlows: (newChargerFlows) =>
    set((state) => ({
      chargerFlows: [...state.chargerFlows, ...newChargerFlows],
    })),
  setEditChargerFlow: (flow) =>
    set(() => ({
      editChargerFlow: flow,
    })),
  setEditChargerFlowsErrors: (errors) =>
    set(() => ({
      editChargerFlowErrors: errors,
    })),
  resetChargerFlows: () => set({ chargerFlows: [] }),
  resetEditChargerFlow: () => set({ editChargerFlow: null }),
  resetEditChargerFlowErrors: () => set({ editChargerFlowErrors: null }),
}));

export const useAllChargerFlowsStore = () =>
  useAllChargerFlowsStorage((state) => state.chargerFlows);

export const useSetAllChargerFlowsStore = () =>
  useAllChargerFlowsStorage((state) => state.setChargerFlows);

export const useResetAllAllChargerFlowsStore = () =>
  useAllChargerFlowsStorage((state) => state.resetChargerFlows);

export const useEditChargerFlow = () => useAllChargerFlowsStorage((state) => state.editChargerFlow);

export const useSetEditChargerFlow = () =>
  useAllChargerFlowsStorage((state) => state.setEditChargerFlow);

export const useResetEditChargerFlow = () =>
  useAllChargerFlowsStorage((state) => state.resetEditChargerFlow);

export const useEditChargerFlowErrors = () =>
  useAllChargerFlowsStorage((state) => state.editChargerFlowErrors);

export const useSetEditChargerFlowErrors = () =>
  useAllChargerFlowsStorage((state) => state.setEditChargerFlowsErrors);

export const useResetEditChargerFlowErros = () =>
  useAllChargerFlowsStorage((state) => state.resetEditChargerFlowErrors);
